/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import cx from 'classnames';

import { ButtonSanity } from 'sarsaparilla/src/button-sanity';

import type { SearchResultItem } from '../../api/search/search.types';
import { CardStarRating } from './CardStarRating';
import { CardPrice } from './CardPrice';

import styles from './CardFooter.module.scss';

interface CardFooterProps {
    item: SearchResultItem;
}

export function CardFooter({ item }: CardFooterProps) {
    if (item.park_pass_facility_id) {
        return (
            <div className={cx(styles.footer, styles.hasPass)}>
                <ButtonSanity
                    size="sm"
                    appearance="soft-brand"
                    onClick={() => {
                        window.open(`/sitepass/${item.park_pass_facility_id}`, '_blank');
                    }}
                    aria-label={`Buy pass for ${item.name}`}
                    role="link"
                >
                    Buy a Pass
                </ButtonSanity>
            </div>
        );
    }

    // if there's no rating or price, return null
    if (!item.average_rating && !item.price_range) {
        return <div className={styles.emptyFooter} />;
    }

    return (
        <div className={styles.footer}>
            <CardStarRating item={item} />
            <CardPrice item={item} />
        </div>
    );
}

// cSpell:ignore sitepass
